/**
 * User Title System Logic
 * 
 * Defines the progression system for User Titles based on Level and Tech Stack.
 */

export const LEVEL_TITLES = [
    { min: 1, max: 3, title: "LUNA Cadet", icon: "fa-user-astronaut" },
    { min: 4, max: 6, title: "Code Scout", icon: "fa-compass" },
    { min: 7, max: 9, title: "Vanguard", icon: "fa-shield-halved" },
    { min: 10, max: 14, title: "Elite Dev", icon: "fa-medal" },
    { min: 15, max: 19, title: "Tech Commander", icon: "fa-jet-fighter" },
    { min: 20, max: 99, title: "Code Legend", icon: "fa-crown" },
];

export const STACK_TITLES = {
    python: "Pyromancer",
    javascript: "JS Weaver",
    java: "Data Architect",
    cpp: "System Core",
    c: "Kernel Master",
    default: "Polyglot",
};

/**
 * Returns the Title object for a given level.
 * @param {number} level 
 * @returns {object} { title, icon }
 */
export function getLevelTitle(level) {
    const levelNum = parseInt(level, 10) || 1;
    const match = LEVEL_TITLES.find(t => levelNum >= t.min && levelNum <= t.max) || LEVEL_TITLES[0];
    return match;
}

/**
 * Returns the Stack Title for a given language.
 * @param {string} language 
 * @returns {string}
 */
export function getStackTitle(language) {
    if (!language || language === 'all') return STACK_TITLES.default;
    return STACK_TITLES[language.toLowerCase()] || STACK_TITLES.default;
}

/**
 * Returns the full composite title for the user.
 * e.g. "Code Scout (JS Weaver)"
 * @param {number} level 
 * @param {string|array} languages - Array of learned languages or selected language string
 * @returns {string}
 */
export function getUserFullTitle(level, languages) {
    const lvlTitle = getLevelTitle(level).title;

    if (!languages || (Array.isArray(languages) && languages.length === 0)) {
        return lvlTitle;
    }

    // Determine primary language (simplified: take first or selected)
    let primaryLang = 'default';
    if (Array.isArray(languages)) {
        primaryLang = languages[0]; // Naive: take first learned
    } else if (typeof languages === 'string' && languages !== 'all') {
        primaryLang = languages;
    }

    const stackTitle = getStackTitle(primaryLang);
    return `${lvlTitle} • ${stackTitle}`;
}
